import { ReactNode, useState } from 'react';
import { components } from '@api/play-account/generated';

import { Badge } from '@ui/components/Badge';
import { DateView } from '@ui/components/DateView';
import { LinearChart } from '@ui/components/LinearChart/LinearChart';
import { Tabs } from '@ui/components/Tabs';

import { ChartPoint } from '@features/shared/api/typings';
import { PlayerGamesListPreview } from '@features/user/ui/PlayerGamesListPreview/PlayerGamesListPreview';

import styles from './PlayerEloStat.module.css';

const GRAPH_TABS: {
  label: ReactNode;
  value: components['schemas']['EloHistoryPeriodType'];
}[] = [
  { label: 'по дням', value: 'Daily' },
  { label: 'нед', value: 'Weekly' },
  { label: 'мес', value: 'Monthly' },
];

type EloStatProps = {
  title: string;
  icon: ReactNode;
  gameCount?: number;
  rank?: number;
  points?: ChartPoint[];
  start?: number;
  end?: number;
  maxRank?: number;
  minRank?: number;
  tab: components['schemas']['EloHistoryPeriodType'];
  onTabChange: (newTab: components['schemas']['EloHistoryPeriodType']) => void;
  games?: components['schemas']['UserGameHistoryItemDto'][];
  onGameClick: (game: components['schemas']['UserGameHistoryItemDto']) => void;
  openShowFullGamesList: () => void;
  renderShieldQuickPeek: (userId: string) => ReactNode;
};
export function PlayerEloStat({
  title,
  icon,
  gameCount,
  rank,
  points,
  tab,
  onTabChange,
  start,
  end,
  maxRank,
  minRank,
  games,
  onGameClick,
  openShowFullGamesList,
  renderShieldQuickPeek,
}: EloStatProps) {
  const [isGamesCollapsed, onGamesCollapsedChange] = useState(true);

  return (
    <div className={styles.eloStat}>
      <div className={styles.rankLabel}>
        <div className={styles.rankTitle}>{title}</div>
        {gameCount !== undefined && (
          <Badge className={styles.gameCount} size="xs">
            {gameCount}
          </Badge>
        )}
      </div>
      <div className={styles.rank}>
        <div className={styles.rankValue}>
          <div className={styles.clockControlIcon}>{icon}</div>
          {rank}
        </div>

        <Tabs heavy tabs={GRAPH_TABS} onChange={onTabChange} value={tab} />
      </div>

      {points && points.length > 0 && (
        <div className={styles.chartContainer}>
          <LinearChart className={styles.chart} points={points} showTicks />

          <div className={styles.dateRange}>
            <DateView date={start} humanReadableDay={false} shortMonth />
            <DateView date={end} humanReadableDay={false} shortMonth />
          </div>

          <div className={styles.rankRange}>
            <div className={styles.rankExtremum}>
              <div className={styles.label}>
                Макс.
                <br />
                рейтинг
              </div>
              <div className={styles.value}>{maxRank}</div>
            </div>
            <div className={styles.rankExtremum}>
              <div className={styles.label}>
                Мин.
                <br />
                рейтинг
              </div>
              <div className={styles.value}>{minRank}</div>
            </div>
          </div>
        </div>
      )}

      {games && games.length > 0 && (
        <PlayerGamesListPreview
          className={styles.gamesList}
          games={games}
          isCollapsed={isGamesCollapsed}
          onCollapsedChange={onGamesCollapsedChange}
          onShowAll={openShowFullGamesList}
          onGameClick={onGameClick}
          renderShieldQuickPeek={renderShieldQuickPeek}
        />
      )}
    </div>
  );
}
